import { useEffect, useState } from 'react';
import { userSession } from '../utils/userSession.js';
import ImageUrlField from './ImageUrlField.js';
import DashboardModal from './DashboardModal.js';
import FormTabs, { FormTabPanel } from './FormTabs.js';

const TABS = [
  { id: 'business', label: 'Business' },
  { id: 'contact', label: 'Contact' }
];

export default function EditPromoter({ isOpen, onClose, onPromoterUpdated, promoterData }) {
  const [tab, setTab] = useState('business');
  const [formData, setFormData] = useState({
    businessName: promoterData?.BusinessName || '',
    contactName: promoterData?.ContactName || '',
    contactPhone: promoterData?.ContactPhone || '',
    contactEmail: promoterData?.ContactEmail || '',
    websiteLink: promoterData?.WebsiteLink || '',
    organiserImage: promoterData?.organiserImage || '',
    reach: promoterData?.Reach || 'Local',
    discipline: 'Drift'
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setTab('business');
      setError('');
    }
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const response = await fetch(
        `https://r7ej0e9i28.execute-api.ap-southeast-2.amazonaws.com/dev/promoters/${promoterData.OrganiserID}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            ...formData,
            userId: userSession.getUserId()
          })
        }
      );

      if (!response.ok) {
        throw new Error('Failed to update promoter');
      }

      if (onPromoterUpdated) {
        onPromoterUpdated();
      }
      onClose();
    } catch (err) {
      setError('Failed to update promoter. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  if (!isOpen) return null;

  return (
    <DashboardModal
      title="Edit Promoter Details"
      onClose={onClose}
      onSubmit={handleSubmit}
      isLoading={isLoading}
      error={error}
      onRevealTab={setTab}
      tabs={<FormTabs tabs={TABS} active={tab} onChange={setTab} />}
    >
      <FormTabPanel id="business" active={tab}>
        <div>
          <label htmlFor="businessName" className="block text-sm font-medium text-gray-700">
            Business Name *
          </label>
          <input
            type="text"
            id="businessName"
            name="businessName"
            required
            value={formData.businessName}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border-gray-300 px-3 py-2 shadow-sm focus:border-slate-500 focus:ring-slate-500"
          />
        </div>

        <div>
          <label htmlFor="reach" className="block text-sm font-medium text-gray-700">
            Reach *
          </label>
          <select
            id="reach"
            name="reach"
            required
            value={formData.reach}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border-gray-300 px-3 py-2 shadow-sm focus:border-slate-500 focus:ring-slate-500"
          >
            <option value="Local">Local</option>
            <option value="National">National</option>
            <option value="Global">Global</option>
          </select>
        </div>

        <div>
          <label htmlFor="websiteLink" className="block text-sm font-medium text-gray-700">
            Website Link
          </label>
          <input
            type="url"
            id="websiteLink"
            name="websiteLink"
            value={formData.websiteLink}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border-gray-300 px-3 py-2 shadow-sm focus:border-slate-500 focus:ring-slate-500"
          />
        </div>

        <ImageUrlField
          id="organiserImage"
          name="organiserImage"
          label="Logo URL"
          type="organiserImage"
          entityId={promoterData?.OrganiserID}
          value={formData.organiserImage}
          onChange={(organiserImage) => setFormData((prev) => ({ ...prev, organiserImage }))}
        />
      </FormTabPanel>

      <FormTabPanel id="contact" active={tab}>
        <div>
          <label htmlFor="contactName" className="block text-sm font-medium text-gray-700">
            Contact Name *
          </label>
          <input
            type="text"
            id="contactName"
            name="contactName"
            required
            value={formData.contactName}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border-gray-300 px-3 py-2 shadow-sm focus:border-slate-500 focus:ring-slate-500"
          />
        </div>

        <div>
          <label htmlFor="contactPhone" className="block text-sm font-medium text-gray-700">
            Contact Phone *
          </label>
          <input
            type="tel"
            id="contactPhone"
            name="contactPhone"
            required
            value={formData.contactPhone}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border-gray-300 px-3 py-2 shadow-sm focus:border-slate-500 focus:ring-slate-500"
          />
        </div>

        <div>
          <label htmlFor="contactEmail" className="block text-sm font-medium text-gray-700">
            Contact Email *
          </label>
          <input
            type="email"
            id="contactEmail"
            name="contactEmail"
            required
            value={formData.contactEmail}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border-gray-300 px-3 py-2 shadow-sm focus:border-slate-500 focus:ring-slate-500"
          />
        </div>
      </FormTabPanel>
    </DashboardModal>
  );
}
